import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";

interface Section {
  label: string;
  links: { to: string; label: string }[];
}

const SECTIONS: Section[] = [
  {
    label: "Getting Started",
    links: [{ to: "/docs/getting-started", label: "Overview" }],
  },
  {
    label: "Concepts",
    links: [{ to: "/docs/concepts", label: "Overview" }],
  },
  {
    label: "Workflows",
    links: [{ to: "/docs/scenario-authoring", label: "Scenario authoring" }],
  },
  {
    label: "Reference",
    links: [{ to: "/docs/troubleshooting", label: "Troubleshooting" }],
  },
];

export function DocsNav() {
  return (
    <nav className="w-56 flex-shrink-0 space-y-4 py-4 pr-4">
      {SECTIONS.map((section) => (
        <div key={section.label}>
          <p className="text-[10px] font-medium uppercase tracking-wide text-muted-foreground/70 mb-1">
            {section.label}
          </p>
          <ul className="space-y-0.5">
            {section.links.map((link) => (
              <li key={link.to}>
                <NavLink
                  to={link.to}
                  aria-label={`${section.label} — ${link.label}`}
                  className={({ isActive }) =>
                    cn(
                      "block px-2 py-1 rounded text-sm transition-colors",
                      isActive
                        ? "bg-accent text-accent-foreground"
                        : "text-foreground hover:bg-muted/40",
                    )
                  }
                >
                  {link.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </nav>
  );
}
